// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ValuePrincipal_wrapper__3t5Z5","icon":"ValuePrincipal_icon__3WEqs","avatar":"ValuePrincipal_avatar__2IiC8"};